export const PLANTFORM_MODAL_OPEN = "PLANTFORM_MODAL_OPEN"

export const togglePlantform = () => dispatch => {
    dispatch({type: PLANTFORM_MODAL_OPEN}); 
} 